module.exports = __webpack_public_path__ + "img/gmail.da19cd51.svg";